import amana from "@/assets/images/static/brands/amana.webp";
import asko from "@/assets/images/static/brands/asko.webp";
import awanti from "@/assets/images/static/brands/awanti.webp";
import azureRefrigeration from "@/assets/images/static/brands/azureRefrigeration.webp";

import beko from "@/assets/images/static/brands/beko.webp";
import bestVentillation from "@/assets/images/static/brands/bestVentillation.webp";
import Bertazzoni from "@/assets/images/static/brands/Bertazzoni.webp";
import bluestar from "@/assets/images/static/brands/bluestar.webp";
import bosch from "@/assets/images/static/brands/bosch.png";
import broan from "@/assets/images/static/brands/Broan/logo.png";
import viking from "@/assets/images/static/brands/viking.png";
import zline from "@/assets/images/static/brands/Zline.webp";

import COVE from "@/assets/images/static/brands/COVE.webp";
import DACOR from "@/assets/images/static/brands/DACOR.webp";
import exectrolux from "@/assets/images/static/brands/Electrolux/Electrolux_logo.webp";
import FisherPaykelCanada from "@/assets/images/static/brands/FisherPaykelCanada-logo.webp";
import foster from "@/assets/images/static/brands/foster.webp";
import GAGGENAU from "@/assets/images/static/brands/GAGGENAU.webp";
import JENNAIR from "@/assets/images/static/brands/JENNAIR.webp";
import LIEBHERR from "@/assets/images/static/brands/LIEBHERR.webp";
import MIELE from "@/assets/images/static/brands/MIELE.png";
import MONOGRAM from "@/assets/images/static/brands/MONOGRAM.webp";
import signature from "@/assets/images/static/brands/signature.webp";
import wasteKing from "@/assets/images/static/brands/wasteKing.webp";

import smeg from "@/assets/images/static/brands/smeg.webp";
import SubZero from "@/assets/images/static/brands/Sub-Zero.webp";
import Thermador from "@/assets/images/static/brands/Thermador.png";
import ThorKitchen from "@/assets/images/static/brands/ThorKitchen-logo.webp";
import VentAHood from "@/assets/images/static/brands/VentAHood.webp";
import Wolf from "@/assets/images/static/brands/Wolf.webp";

import cafe from "@/assets/images/static/brands/Cafe/Cafe_logo.webp";
import dcs from "@/assets/images/static/brands/dcs.webp";
import elica from "@/assets/images/static/brands/elica-logo.webp";
import forno from "@/assets/images/static/brands/forno.webp";
import frigidaireGallery from "@/assets/images/static/brands/frigidaire-gallery.webp";
import frigidaireProfessional from "@/assets/images/static/brands/frigidaire-professional.webp";
import frigidaire from "@/assets/images/static/brands/frigidaire.webp";
import geappliances from "@/assets/images/static/brands/geappliances.png";
import geprofile from "@/assets/images/static/brands/geprofile.webp";
import haier from "@/assets/images/static/brands/haier.webp";
import hotpoint from "@/assets/images/static/brands/hotpoint.webp";
import kitchenaid from "@/assets/images/static/brands/kitchenaid.png";
import lgStudio from "@/assets/images/static/brands/lg-studio.webp";
import lg from "@/assets/images/static/brands/lg.png";
import marvel from "@/assets/images/static/brands/marvel.webp";
import maytag from "@/assets/images/static/brands/Maytag/Maytag_logo.webp";
import premier from "@/assets/images/static/brands/Premier.webp";
import perlick from "@/assets/images/static/brands/Perlick/Perlick_logo.png";
import samsung from "@/assets/images/static/brands/samsung.webp";
import summit from "@/assets/images/static/brands/summit.webp";
import speedQueen from "@/assets/images/static/brands/speed-queen.webp";
import TrueResidential_logo from "@/assets/images/static/brands/TrueResidential/TrueResidential_logo.webp";

import sharp from "@/assets/images/static/brands/sharp.webp";
import uline from "@/assets/images/static/brands/uline.webp";
import Unique from "@/assets/images/static/brands/Unique.webp";
import whirlpool from "@/assets/images/static/brands/whirlpool.webp";
import zephyr from "@/assets/images/static/brands/zephyr.webp";

export const brandList = [
  {
    name: "Asko",
    src: asko,
    link: "asko",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Bertazzoni",
    src: Bertazzoni,
    link: "bertazzoni",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Bluestar",
    src: bluestar,
    link: "bluestar",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Cove",
    src: COVE,
    link: "cove",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Dacor",
    src: DACOR,
    link: "dacor",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "DCS",
    src: dcs,
    link: "dcs",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Fisher & Paykel",
    src: FisherPaykelCanada,
    link: "fisher-paykel",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Forno",
    src: forno,
    link: "forno",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Foster",
    src: foster,
    link: "foster",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Gaggenau",
    src: GAGGENAU,
    link: "gaggenau",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Jennair",
    src: JENNAIR,
    link: "jennair",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Liebherr",
    src: LIEBHERR,
    link: "liebherr",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Marvel",
    src: marvel,
    link: "marvel",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Miele",
    src: MIELE,
    link: "miele",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Monogram",
    src: MONOGRAM,
    link: "monogram",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Signature Kitchen Suite",
    src: signature,
    link: "signature-kitchen-suite",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  
  {
      name: "Smeg",
      src: smeg,
      link: "all-brands/smeg",
      isLuxury:true,
      isMajor:false,
      isAll: true
  },
  {
    name: "Sub Zero Refrigerators",
    src: SubZero,
    link: "sub-zero",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
    { 
        name: "True Residential", 
        src: TrueResidential_logo, 
        link: "true-residential",
        isLuxury:true,
        isMajor:false,
        isAll: true
    },
    { 
        name: "Thermador",
        src: Thermador, 
        link: "thermador",
        isLuxury:true,
        isMajor:false,
        isAll: true
    },
    { 
        name: "Thor Kitchen", 
        src: ThorKitchen,
        link: "thor-kitchen",
        isLuxury:true,
        isMajor:false,
        isAll: true
    },
    { 
        name: "U Line", 
        src: uline, 
        link: "u-line",
        isLuxury:true,
        isMajor:false,
        isAll: true
    },
    { 
        name: "Unique", 
        src: Unique, 
        link: "unique-appliances",
        isLuxury:true,
        isMajor:false,
        isAll: true
    },
    { 
        name: "Vent A Hood",
        src: VentAHood, 
        link: "ventahood",
        isLuxury:true,
        isMajor:false,
        isAll: true
    },
    { 
        name: "Viking", 
        src: viking, 
        link: "viking",
        isLuxury:true,
        isMajor:false,
        isAll: true
    },
    { 
        name: "Wolf", 
        src: Wolf, 
        link: "wolf",
        isLuxury:true,
        isMajor:false,
        isAll: true
    },
    { 
        name: "Zline", 
        src: zline, 
        link: "zline",
        isLuxury:true,
        isMajor:false,
        isAll: true
    },
    { 
        name: "Amana", 
        src: amana, 
        link: "amana",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "Avanti", 
        src: awanti, 
        link: "avanti",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "Azure Refrigeration", 
        src: azureRefrigeration, 
        link: "all-brands/azure-refrigeration",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "Beko", 
        src: beko,
        link: "beko",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    {
        name: "Best Ventillation",
        src: bestVentillation,
        link: "best-ventillation",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "Bosch", 
        src: bosch, 
        link: "bosch" ,
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "Broan Ventillation", 
        src: broan, 
        link: "broan-ventillation",
        isLuxury:false,
        isMajor:true,
        isAll: true 
    },
    { 
        name: "Cafe", 
        src: cafe, 
        link: "cafe",
        isLuxury:false,
        isMajor:true,
        isAll: true 
    },
    { 
        name: "Electrolux", 
        src: exectrolux, 
        link: "electrolux",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "Elica", 
        src: elica, 
        link: "elica",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "Frigidaire", 
        src: frigidaire, 
        link: "frigidaire",
        isLuxury:false,
        isMajor:true,
        isAll: true 
    },
    { 
        name: "Frigidaire Gallery",
        src: frigidaireGallery,
        link: "frigidaire-gallery",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    {
      name: "Frigidaire Professional",
      src: frigidaireProfessional,
      link: "frigidaire-pro",
      isLuxury:false,
      isMajor:true,
      isAll: true
    },
    { 
        name: "GE Appliances", 
        src: geappliances, 
        link: "ge-appliances",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "GE Profile",
        src: geprofile, 
        link: "ge-profile",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "Haier", 
        src: haier, 
        link: "haier",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "Hotpoint", 
        src: hotpoint, 
        link: "hotpoint",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "KitchenAid", 
        src: kitchenaid, 
        link: "kitchenaid",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "LG", 
        src: lg, 
        link: "lg",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "LG Studio",
        src: lgStudio, 
        link: "lg-studio",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "Maytag", 
        src: maytag, 
        link: "maytag",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    {
      name: "Perlick",
      src: perlick,
      link: "perlick",
      isLuxury: false,
      isMajor: true,
      isAll: true,
    },
    {
        name: "Premier", 
        src: premier, 
        link: "premier",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "Samsung Appliances", 
        src: samsung, 
        link: "samsung",
        isLuxury:false,
        isMajor:true,
        isAll: true 
    },
    {
        name: "Sharp", 
        src: sharp, 
        link: "sharp",
        isLuxury:false,
        isMajor:true,
        isAll: true
     },
    { 
        name: "Speed Queen", 
        src: speedQueen,
        link: "speed-queen",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "Summit", 
        src: summit, 
        link: "summit",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "Waste King", 
        src: wasteKing, 
        link: "all-brands/waste-king",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
    { 
        name: "Whirlpool", 
        src: whirlpool, 
        link: "whirlpool",
        isLuxury:false,
        isMajor:true,
        isAll: true 
    },
    { 
        name: "Zephyr", 
        src: zephyr, 
        link: "zephyr",
        isLuxury:false,
        isMajor:true,
        isAll: true
    },
]

export const dashboardBrandList = [
  { 
    name: "Bosch", 
    src: bosch, 
    link: "bosch" ,
    isLuxury:false,
    isMajor:true,
    isAll: true
  },
  { 
    name: "LG", 
    src: lg, 
    link: "lg",
    isLuxury:false,
    isMajor:true,
    isAll: true
  },
  { 
    name: "Ge Appliances", 
    src: geappliances, 
    link: "ge-appliances",
    isLuxury:false,
    isMajor:true,
    isAll: true
  },
  { 
    name: "Thermador",
    src: Thermador, 
    link: "thermador",
    isLuxury:true,
    isMajor:false,
    isAll: true
  },
  {
    name: "Miele",
    src: MIELE,
    link: "miele",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  { 
    name: "KitchenAid", 
    src: kitchenaid, 
    link: "kitchenaid",
    isLuxury:false,
    isMajor:true,
    isAll: true
  },
]
export const authorizeBrandList = [
    { 
      name: "LG", 
      src: lg, 
      link: "lg",
      isLuxury:false,
      isMajor:true,
      isAll: true
  },
  { 
    name: "Thermador",
    src: Thermador, 
    link: "thermador",
    isLuxury:true,
    isMajor:false,
    isAll: true
  },
  { 
    name: "Bosch", 
    src: bosch, 
    link: "bosch" ,
    isLuxury:false,
    isMajor:true,
    isAll: true
  },
  { 
    name: "Ge Appliances", 
    src: geappliances, 
    link: "ge-appliances",
    isLuxury:false,
    isMajor:true,
    isAll: true
  },
  {
    name: "Sub Zero Refrigerators",
    src: SubZero,
    link: "sub-zero",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  { 
    name: "Ge Profile",
    src: geprofile, 
    link: "ge-profile",
    isLuxury:false,
    isMajor:true,
    isAll: true
  },
  { 
    name: "Wolf", 
    src: Wolf, 
    link: "wolf",
    isLuxury:true,
    isMajor:false,
    isAll: true
  },
  {
    name: "Miele",
    src: MIELE,
    link: "miele",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  {
    name: "Monogram",
    src: MONOGRAM,
    link: "monogram",
    isLuxury: true,
    isMajor: false,
    isAll: true,
  },
  { 
    name: "Frigidaire", 
    src: frigidaire, 
    link: "frigidaire",
    isLuxury:false,
    isMajor:true,
    isAll: true 
  },
  { 
    name: "KitchenAid", 
    src: kitchenaid, 
    link: "kitchenaid",
    isLuxury:false,
    isMajor:true,
    isAll: true
  },
  { 
    name: "Cafe", 
    src: cafe, 
    link: "cafe",
    isLuxury:false,
    isMajor:true,
    isAll: true 
  },
]

// Use Map for O(1) brand lookup
export const brandMap = new Map(
  brandList.map((brand) => [brand.link, brand])
);